import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import useTranslation from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';

const createStyles = (colors) => StyleSheet.create({
  dropdownHeader: {
    paddingVertical: 8,
    paddingHorizontal: 8,
    marginBottom: 8,
  },
  dropdownHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  requiredRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  dropdownHeaderDisabled: {
    paddingBottom: 4,
    marginBottom: 0,
  },
  dropdownHeaderText: {
    color: colors.text_color_tertiary,
    fontSize: 14,
  },
  dropdownHeaderTextDescription: {
    color: colors.text_color_tertiary,
    fontSize: 12,
    marginTop: 5,
  },
  dropdownHeaderTight: {
    paddingBottom: 5,
    marginBottom: 0,
  },
  requiredBadge: {
    backgroundColor: 'rgba(255, 40, 40, 0.12)',
    color: 'rgb(255, 40, 40)',
    borderRadius: 6,
    paddingVertical: 2,
    paddingHorizontal: 6,
    fontSize: 10,
    textTransform: 'uppercase',
  },
});

const DropdownHeader = ({
  displayName,
  description,
  isRequired = false,
  isRequirementValid = false,
  isDisabled = false,
  isTight = false,
  showSeparator = true,
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const styles = useMemo(() => createStyles(colors), [colors]);
  // Don't render if no displayName
  if (!displayName) return null;

  return (
    <>
      <View style={[
        styles.dropdownHeader,
        isTight && styles.dropdownHeaderTight,
        isDisabled && styles.dropdownHeaderDisabled
      ]}>
        <View style={styles.dropdownHeaderRow}>
          <Text style={styles.dropdownHeaderText}>{displayName}</Text>
          {isRequired && (
            <View style={styles.requiredRow}>
              <Text style={styles.requiredBadge}>{t('chatInput.required')}</Text>
              {isRequirementValid && <Icon name="check" size={12} color="rgb(16, 185, 129)" />}
            </View>
          )}
        </View>
        {description && (
          <Text style={styles.dropdownHeaderTextDescription}>{description}</Text>
        )}
      </View>
      {showSeparator && <DropdownMenu.Separator />}
    </>
  );
};

export default DropdownHeader;

